/**
 * Name the `GoogleTagManager` destination registers itself under.
 *
 * Held here rather than as a literal in the destination, because `Analytics` has
 * to look that destination up by name to reach the `dataLayer` without fanning an
 * event out to every other destination.
 */
export const GTM_DESTINATION_NAME = 'GoogleTagManager';

/**
 * Names the other destinations register under, for `track(event, properties, { destinations })`.
 */
export const RUDDERSTACK_DESTINATION_NAME = 'rudderstack';
export const FEATURE_FLAGS_DESTINATION_NAME = 'featureFlags';
export const OPENOBSERVE_DESTINATION_NAME = 'OpenObserve';

/**
 * `dataLayer` event announcing that the organization data source has been resolved.
 *
 * It exists because the value is resolved over the network, so it lands after the
 * page view of a first visit to an organization. Beamer reads its filter once, at
 * load, from `beamer_config` — a value arriving later is invisible to it unless a
 * tag calls `Beamer.update()`, and that tag needs an event to fire on.
 *
 * Sent to Google Tag Manager alone: it reports no user action, so it belongs in the
 * `dataLayer` that drives tags, not in the product event stream.
 */
export const ORG_DATA_SOURCE_RESOLVED_EVENT = 'org_data_source_resolved';
